// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1521b7816c3cd34973bc4fe9ede57d156633ca23/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};